import { API_BASE_URL } from "../../constant/constant";
import React, { useEffect, useState } from "react";
import Joyride from "react-joyride";
import axios from "axios";
import { ContentDiv, CardText, Heading } from "./Style";
import AIAssistantVideo from "../../assets/AI assistent.mp4";
import AssistantAgendaVideo from "../../assets/Assitent agenda.mp4";
import AutomatiseringenVideo from "../../assets/Automatiseringen.mp4";
import SkillsVideo from "../../assets/Skills.mp4";

const Tour = ({ run, handleClose }) => {
  const steps = [
    {
      target: ".nav-item-0", // Target the first nav item
      disableBeacon: true,
      hideBackButton: true,
      content: (
        <ContentDiv>
          <CardText>1/3</CardText>
          <Heading>AI-assistent</Heading>
          <video
            src={AIAssistantVideo}
            autoPlay
            loop
            muted
            playsInline
            controls
            style={{
              width: "100%",
              borderRadius: "0.5rem",
              marginTop: "1rem",
              marginBottom: "1rem"
            }}
          />
          <CardText style={{ fontWeight: "400", textAlign: "left" }}>
            Ga naar de assistent om een gesprek te beginnen en zaken te regelen! Uw assistent werkt naadloos samen met alle hulpmiddelen om u efficiënt te helpen uw taken te volbrengen.
          </CardText>
          <div style={{ display: "flex", marginTop: "2rem" }}>
            <CardText>Niet je eerste keer?</CardText>
            <CardText
              onClick={handleClose}
              style={{ fontWeight: "600", textDecorationLine: "underline" }}
            >
              Overslaan
            </CardText>
          </div>
        </ContentDiv>
      ),
    },
    {
      target: "#grid-item-0", // Target the second nav item
      hideBackButton: true,
      content: (
        <ContentDiv>
          <CardText>2/3</CardText>
          <Heading>App starten</Heading>

          <CardText style={{ fontWeight: "400", textAlign: "left" }}>Klik op de knop “Start App” om toegang te krijgen tot elke app, inclusief e-mailautomatisering, vergaderingen, takenlijsten en meer!
          </CardText>
          <div style={{ display: "flex", marginTop: "2rem" }}>
            <CardText>Niet je eerste keer?</CardText>
            <CardText
              onClick={handleClose}
              style={{ fontWeight: "600", textDecorationLine: "underline" }}
            >
              Overslaan
            </CardText>
          </div>
        </ContentDiv>
      ),
    },
    {
      target: ".nav-item-settings", // Target the third nav item
      hideBackButton: true,
      content: (
        <ContentDiv>
          <CardText>3/3</CardText>
          <Heading>Ontdek Instellingen</Heading>
          <CardText style={{ fontWeight: "400", textAlign: "left" }}>
            Beheer uw wachtwoord, profiel, betaalmethode, transactiegeschiedenis en beheer uw abonnement
          </CardText>
          <div style={{ display: "flex", marginTop: "2rem" }}>
            <CardText>Niet je eerste keer?</CardText>
            <CardText
              onClick={handleClose}
              style={{ fontWeight: "600", textDecorationLine: "underline" }}
            >
              Overslaan
            </CardText>
          </div>
        </ContentDiv>
      ),
    },
  ];

  const handleApiCall = () => {
    const email = localStorage.getItem("email");
    if (email) {
      axios
        .post(`${API_BASE_URL}/api/auth/onboard-user`, { email })
        .then((response) => {
          console.log("API response:", response.data);
        })
        .catch((error) => {
          console.error("API error:", error);
        });
    } else {
      console.error("Email not found in local storage");
    }
  };

  const handleTourCallback = (data) => {
    const { status, action } = data;
    if (status === "finished" || action === "skip") {
      handleClose();
      handleApiCall();
    }
  };

  return (
    <Joyride
      steps={steps}
      run={run}
      continuous={true}
      callback={handleTourCallback}
      styles={{
        options: {
          zIndex: 10000,
          width: "25rem",
          backgroundColor: "#51307F",
          arrowColor: "#51307F",
          textColor: "#FFF",
          beaconSize: 0,
        },
        buttonNext: {
          display: "flex",
          padding: "0.625rem 1.125rem",
          justifyContent: "center",
          alignItems: "center",
          gap: "0.5rem",
          borderRadius: "6.25rem",
          background: "#FFF",
          color: "#313133",
        },
        spotlight: {
          borderRadius: "0.75rem",
        },
      }}
    />
  );
};

export default Tour;